var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPinStart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 28C55 42.9117 42.9117 55 28 55C13.0883 55 1 42.9117 1 28C1 13.0883 13.0883 1 28 1C42.9117 1 55 13.0883 55 28Z",
    fill: "#E7F7F3",
    stroke: "#0AAF87",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.191 29.2213L32.3927 36.033L20.5946 42.8447C20.146 43.1036 19.6326 43.1036 19.184 42.8447C18.7354 42.5857 18.4788 42.141 18.4788 41.623V27.9997V14.3763C18.4788 13.8584 18.7355 13.4137 19.184 13.1547C19.6326 12.8957 20.146 12.8957 20.5946 13.1547L32.3927 19.9663L44.191 26.778C44.6395 27.037 44.8962 27.4817 44.8962 27.9995C44.8962 28.5177 44.6395 28.9622 44.191 29.2213Z",
    fill: "#0AAF87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinStart);
export default __webpack_public_path__ + "static/media/MapPinStart.ac02d46015caf7af9adee13cedf81984.svg";
export { ForwardRef as ReactComponent };